<template>
  <div class="user-info">
    <h3>Hi，{{user.username}}</h3>
    <ul>
      <li>
        <span v-if="user.account_type==1">总信用额 : </span>
        <span v-else>总现金额 : </span>
        <span class="default-color" v-if="user.status==3">冻结</span>
        <span class="default-color" v-else>{{user.credit_limit}}</span>
      </li>
      <li>
        <span>可用余额 : </span>
        <span class="default-color" v-if="user.status==3">冻结</span>
        <span class="default-color" v-else><mark>{{user.credit_balance}}</mark></span>
      </li>
      <li>
        <span>未结金额 : </span>
        <span class="default-color"><mark>{{user.un_settle_sum}}</mark></span>
      </li>
      <li>
        <span>用户类型 : </span>
        <span class="default-color" v-if="user.account_type == 1">信用盘<!-- <mark>{{user.market}}</mark>--></span>
        <span class="default-color" v-else-if="user.account_type == 2">现金盘<!-- <mark>{{user.market}}</mark>--></span>
      </li>
      <li>
        <span>盘口选择 : </span>
        <select v-model="user.market_default" @change="getmarket">
          <option
          v-for="(item,index) in user.market"
          :key="index"
          :label="item"
          :value="item"></option>
        </select>
      </li>
      <li>
        <span>今日输赢 : </span>
        <span class="default-color" v-if="user.today_bet_result > 0"><span class="red">{{user.today_bet_result}}</span></span>
	<span class="default-color" v-else><mark>{{user.today_bet_result}}</mark></span>
      </li>
    </ul>
    <!--<div class="user-action" v-if="user.account_type == 2">
      <event @click="onRecharge" class="button button-recharge t_btn-d">
        <span>充值</span>
      </event>
      <event @click="onGetMoney" class="button button-cash t_btn-d">
        <span>提现</span>
      </event>
    </div>-->
  </div>
</template>

<script>
  import objectPath from "object-path";
  import {changeMarket} from '../../../service/user';
  import {mapState} from 'vuex';



  export default {
    name: "index",
    computed: {
      ...mapState({
        user: state => state.root.user
      })
    },
    methods: {
      async getmarket(rows) {
        const info = await changeMarket({
          market: this.user.market_default
        });
        const state = this.$store.state.home_PK10;
      const sub_category_id =
        objectPath.get(state, `tabs.${state.curTab}.sub_category_id`) || "";
        //this.$store.dispatch("root/updateUserInfo");
      return this.$store.dispatch("home_PK10/getCurOddsData", {
        sub_category_id,
        lottery_type: this.$route.query.lottery_type || 1,
        category_id: this.$route.query.category_id || 1,
        played_name: state.lhOddsPlayedName
      });
      },
      onRecharge() {
        this.$MessageBox.show('d27', {
          title: '充值啊'
        })
      },
      onGetMoney() {
        this.$MessageBox.show('d26', {
          title: '提现啊'
        })
      }
    }
  }
</script>

<style scoped lang="stylus">
  @import "../../../styles/variable.styl"
  @media screen and (max-width: 900px) {
    .user-info ul li:before{display:none !important}
  }
  mark {
    color #FF9900
    background transparent
  }

  .user-info
    color #000
    padding 0 15px 11px 15px
    font-size 14px
    box-sizing border-box
    font-weight bold
    border-radius 2px

    > h3
      height 27px
      text-align center
      line-height 29px
      border-bottom 1px solid $border-color

    > ul
      margin 0
      padding 0
      text-align left
      padding-bottom 10px
      border-bottom 1px solid #e6e6e6

      > li
        list-style none
        margin-top 3px

        > span
          line-height 1
          vertical-align middle

        > span.default-color {
          color #666
        }

        &:before {
          width 7px
          height 7px
          border 1px solid #999
          margin 0 10px
          content ""
          display inline-block
          border-radius 50%
          box-sizing border-box
          vertical-align center
        }

    > .user-action
      margin-top 11px

      &:after
        clear both
        content ""
        display block

      > .button
        width 88px
        height 34px
        outline none
        padding 0
        box-sizing border-box
        border-width 1px
        border-style solid
        border-radius 2px

        &.button-recharge
          float left

        &.button-cash
          float right
          background linear-gradient(0deg, rgba(189, 189, 189, 1), rgba(236, 236, 236, 1));
          border-color #aaaaaa
       .red
        color #FF0000
</style>



// WEBPACK FOOTER //
// src/components/common/user-info/index.vue